export default {
    namespaced: true,
    state: {
        current: null,
        previous: null,
    },
    mutations: {
        setCurrent (state, { route }) {
            state.previous = state.current;
            state.current = route;
        },
    },
    getters: {
        route: (state) => state.current,
    },
};
